import type { TrackingProps } from '@seek/tealium-adapter/lib-types/types';
import { type Box, TooltipRenderer, Inline } from 'braid-design-system';
import type { ComponentProps, FC, PropsWithChildren, ReactNode } from 'react';

import { IconButtonWithoutTooltip } from './IconButtonWithoutTooltip';

type TooltipRendererProps = ComponentProps<typeof TooltipRenderer>;
type BoxProps = ComponentProps<typeof Box>;

export interface IconButtonLinkProps {
  id: string;
  href?: string;
  tooltip?: TooltipRendererProps['tooltip'];
  icon: ReactNode;
  disabled?: boolean;
  disabledTooltip?: TooltipRendererProps['tooltip'];
  active?: boolean;
  hoverBackground?: BoxProps['background'];
  eventName?: string;
  eventAttributes?: TrackingProps;
  onClick?(): void;
  dataTestId?: string;
}

export const IconButtonLink: FC<PropsWithChildren<IconButtonLinkProps>> = ({
  id,
  href,
  tooltip,
  icon,
  disabled = false,
  disabledTooltip,
  active = false,
  hoverBackground = 'surface',
  eventName,
  eventAttributes,
  onClick,
  dataTestId,
}) => {
  if ((disabled && disabledTooltip) || (!disabled && tooltip)) {
    return (
      <Inline space="none">
        <TooltipRenderer id={id} tooltip={disabled ? disabledTooltip : tooltip}>
          {({ triggerProps }) => (
            <IconButtonWithoutTooltip
              {...triggerProps}
              href={href}
              icon={icon}
              disabled={disabled}
              hoverBackground={hoverBackground}
              active={active}
              eventName={eventName}
              eventAttributes={eventAttributes}
              onClick={onClick}
              dataTestId={dataTestId}
            />
          )}
        </TooltipRenderer>
      </Inline>
    );
  }

  return (
    <IconButtonWithoutTooltip
      href={href}
      icon={icon}
      disabled={disabled}
      active={active}
      eventName={eventName}
      eventAttributes={eventAttributes}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};
